module.exports = __webpack_public_path__ + "static/media/notify.5c232722.mp3";